import { FormField } from '../FormField';

export const DateField = ({ name, title }: DatePickerFieldProps) => {
  return (
    <FormField name={name} title={title} type="date" min="1000-12-31" max="9999-12-31" />
  );
};

interface DatePickerFieldProps {
  name: string;
  title?: string;
  placeholder?: string;
}